export const isArabicText = (text: string): boolean => {
    // Checks for Arabic Unicode range
    //const arabicRegex = /[\u0600-\u06FF]/;
    //return arabicRegex.test(text);
    const arabicChars = text.match(/[\u0600-\u06FF]/g) || [];
    const totalChars = text.replace(/\s/g, '').length; // exclude spaces
    if (totalChars === 0)
        return false;
    const ratio = arabicChars.length / totalChars;
    return ratio >= 0.3;
};
